// Open external links in a new tab
document.addEventListener('DOMContentLoaded', function() {
    const anchorLinks = document.querySelectorAll('a');

    anchorLinks.forEach(function(link) {
        const host = window.location.hostname;

        if (!link.href.includes(host)) {
            link.setAttribute('target', '_blank');
        }
    });
});
